import { template } from 'lodash';

import type { PageMeta } from '@swf/core/models/page';

const buildMetaProperty = (
  property: 'title' | 'description',
  meta: Partial<PageMeta> | undefined,
  locale: string
): string | undefined => {
  const tokens = meta?.tokens?.[locale];
  let builtProperty = meta?.[property];

  if (builtProperty && tokens) {
    try {
      builtProperty = template(builtProperty)(tokens);
    } catch {
      // Use unprocessed property
    }
  }

  return builtProperty;
};

export default buildMetaProperty;
